// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a3c55c76","517":"5a5eac06"}[chunkId] + ".chunk.js";
};